module.exports = __webpack_public_path__ + "7286047a386e08751badcef922e8be7e.png";